import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface TenantProfileMe {
  displayName: string;
  country: string;
  timeZone: string;
  language: string;
  taxMode: number;
  afipCuit: string | null;
  /** Flags de módulos comerciales (ParkingProfile). */
  parkingProfile?: number;
}

export interface ApiEnvelope<T> {
  success?: boolean;
  requestResult?: T;
  body?: T;
}

export interface UpdateTenantProfilePayload {
  displayName: string;
  taxMode: number;
  afipCuit: string | null;
}

@Injectable({ providedIn: 'root' })
export class TenantProfileService {
  private readonly base = `${environment.apiBaseUrl}/api/v1/Tenant`;

  constructor(private http: HttpClient) {}

  getMyTenant(): Observable<TenantProfileMe> {
    return this.http.get<ApiEnvelope<TenantProfileMe>>(`${this.base}/me`).pipe(
      map((res) => this.unwrap(res))
    );
  }

  updateMyTenant(payload: UpdateTenantProfilePayload): Observable<TenantProfileMe> {
    return this.http.put<ApiEnvelope<TenantProfileMe>>(`${this.base}/me`, payload).pipe(
      map((res) => this.unwrap(res))
    );
  }

  private unwrap<T>(res: ApiEnvelope<T>): T {
    const data = res?.requestResult ?? res?.body;
    if (data === undefined || data === null) {
      throw new Error('Respuesta vacía del servidor');
    }
    return data as T;
  }
}
